import { useState } from "react";

const About = () => <div>
  <h2 className="text-lg font-semibold mb-2">About Payment Method Breakdown</h2>
  <p className="text-sm text-gray-600">
    This section provides a detailed breakdown of the payment methods used in transactions. It helps in understanding the distribution of payment methods and their impact on revenue.
  </p>
  <p className="text-sm text-gray-600 mt-2">
    You can filter the data by date range to analyze trends over time. The chart visualizes the total amount processed through each payment method, allowing for quick insights into which methods are most popular or effective.
  </p>
</div>;

const Filter = () => {
  const [activeComponent, setActiveComponent] = useState("About");

  return (
    <div className="max-w-[250px] xl:max-w-[400px] w-full h-full border-l-[0.5px] p-4">
      <div className="flex space-x-4 mb-4">
        <button
          onClick={() => setActiveComponent("About")}
          className={activeComponent === "About" ? "" : "text-gray-500"}
        >
          About
        </button>
      </div>
      {activeComponent === "About" && <About />}
    </div>
  );
};

export default Filter;
